import { Component, Input, OnInit } from '@angular/core';
import { CatBancos, CatMedioPagos, FileUpload , FileUploadOut, PagoConciliacionesInput} from 'app/entidades/entidades';
//Servicios 
import { CatBancosService } from 'app/servicios/cat-bancos.service';
import {FileUploadService} from '../../servicios/file-upload.service';
import {PagoConciliacionesService} from '../../servicios/pago-conciliaciones.service'; 
import { CatMedioPagosService } from '../../servicios/cat-medio-pagos.service';
import { MessageService, SelectItem } from 'primeng/api';

import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";



@Component({
  selector: 'app-conciliacion',
  templateUrl: './conciliacion.component.html',
  styleUrls: ['./conciliacion.component.css']
})
export class ConciliacionComponent implements OnInit {
  columnasTabla: any[];
  columnasTablapagos: any[];
  muestraMensaje = new MuestraMensaje();
  bancos: SelectItem[];
  exportColumns: any[];
  uploadedFiles: any[] = [];
  disabled: boolean = false;
  FileUp: File;
  public IdFactura: Number;
  public idTipoDocumento: Number;
  _catBancos: CatBancos[];
  _selectedBanco: CatBancos;
  _selecteBanco2: any;
  public respuestaF: any;
  public totalRegrstro: number;
  public totalAplicados: number;
  public totalNoAplicados: number;
  public contadorPagados: number = 0; 
  public contadorNpagados:number = 0; 
  public fileUploadInput: FileUpload;
  public fileUploadOut: any;
  public progressBar = false ;
  public FileUploadLayout: FileUploadOut;
  public pagoconciliacionInput: PagoConciliacionesInput;
  public no_pagado: boolean = undefined;
  public pagado: boolean = undefined;
  catMedioPagos: any[] = [];
 /*  showBar() {
    this.progressBar = true;
  } */

  constructor(
    private fileUploadService: FileUploadService,
    private _catBancosService: CatBancosService,
    private catMedioPagosService: CatMedioPagosService,
    private _pagoConciliacionesService: PagoConciliacionesService
     ) { 
    this.bancos = [
      {label:'Seleccione Banco', value:null},
      {label:'Banorte', value:{id:1, name: 'Banorte', code: 'BN'}}
      
      ];
  }
  
  async ngOnInit() {
    await this.getAllCatBancos();
    await this.getAllCatMedioPagos();

  this.columnasTabla = [
    {
      field: "cuentaAgua",
      header: "Cuenta Agua",
      ordenar: false,
      styleHeader: "width: 40 px;",},
     { field: "fecha" ,
      header: "Fecha y hora",
      ordenar: false,
      styleHeader: "width: 120 px;"},
     { field: "importe",
      header: "Importe",
      ordenar: false,
      styleHeader: "width: 40 px;",},
     { field: "id_medio_pago",
      header: "Medio de Pago ",
      ordenar: false,
      styleHeader: "width: 40 px;",},
     { field: "anio",
      header: "Año",
      ordenar: false,
      styleHeader: "width: 40 px;",},
     { field: "periodoParcialidad",
      header: "Período Parcialidad",
      ordenar: false,
      styleHeader: "width: 40 px;",},
     { field: "idTipoPeriodo",
      header: "Tipo Periodo", 
      ordenar: false,
      styleHeader: "width: 40 px;",},
     { field: "tipoPago",
      header: "Concepto de Pago",
      ordenar: false,
      styleHeader: "width: 40 px;",},
      { field: "estatus",
      header: "Estatus",
      ordenar: false,
      styleHeader: "width: 40 px;",},
      { field: "id_factura",
      header: "Folio Factura",
      ordenar: false,
      styleHeader: "width: 40 px;",}
    ];
   
}
  onChange(event) {
    this._selecteBanco2 = null;
    this._selecteBanco2 = event.value;
    console.log(this._selecteBanco2);
  }
  async myUploader(event)
  {
    try
    {

      for(let file of event.files)
      {
        this.progressBar = true;
        this.uploadedFiles = [];
        this.uploadedFiles.push(file);
        console.log("Archivo: ",this.uploadedFiles);
        var input = new FileUpload();
        if(this._selecteBanco2){
            var id_banco = this._selecteBanco2.id;
            //Convierte el archivo .txt en Base64
            this.fileUploadOut=   await   this.convertToBase64(file, this.fileUploadService, this.enviaArchivo, input, id_banco);    
            if(Object.keys(this.fileUploadOut).length > 0){
              
              //this.disabled = false;
              this.fileUploadOut.forEach(element => { 
                element.Mediodescripcion = this.catMedioPagos.find(
                  x => Number.isInteger(parseInt(x.clave, 10)) && parseInt(x.clave, 10) === element.id_medio_pago
                )?.descripcion;
                
              });
            } 
          }else{
            this.progressBar = false;
            this.uploadedFiles = [];
            throw new Error("Seleccionar un banco.");
        }  
      } 

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
      
    } finally {
      console.log("Paso por myUploader");
      this.progressBar = false;
    }     
  } 

  convertToBase64(blob, servicio, callback, input, id_banco ) {
 //Retorna el valor que regreso el callback(enviarArchivo)
 return   new Promise((resolve, reject) => {
      var reader = new FileReader();
          reader.onload = async  function() {
              //Manda llamar el Api con un callback
              let fileUploadOut:FileUploadOut[]  =  await  callback(reader.result,servicio,input, id_banco);
            if (fileUploadOut.length > 0) {
              resolve(fileUploadOut)
            } else {
              reject("error");
            }
          };
           reader.readAsDataURL(blob); 
       });
  };
  async enviaArchivo(base64,fileUploadService, fileUploadInput, id_banco)
  {
    try{
        //El método recibe el archivo en base64, el id de banco, el servicio para ejecutar el API y retorna el Layaut desglosado.
        fileUploadInput.FileBase64 = base64;
        fileUploadInput.id_banco = id_banco;
        const datoRetorno = await fileUploadService.getUpload(fileUploadInput).toPromise();
        return datoRetorno;
      } catch (e) {
        this.muestraMensaje.error(e.message, "top", "center");
      } finally {
        console.log("Paso por enviaArchivo");
      }    
  }
  //Cat Bancos
  async getAllCatBancos(){
    try{
      const datoRetorno = await this._catBancosService.getAll().toPromise();
      this._catBancos = datoRetorno;
      
    } catch (e) {
      if (e.responde) throw { message: e.response.data }
      else throw e;
    } finally {
      console.log("Paso Por getAllCatBancos", this._catBancos)
    }
  }
  async Pagar(){
    try{
      this.progressBar = true;
      this.totalRegrstro = 0;
      this.totalAplicados = 0;
      this.totalNoAplicados = 0;
      this.contadorPagados= 0;
      this.contadorNpagados = 0;
      for (var pago of this.fileUploadOut) {
        var input = new FileUploadOut();
        input = pago;
        try{

          const datoRetorno = await this._pagoConciliacionesService.getPagoConciliaciones(input).toPromise();

          if(datoRetorno){
            this.respuestaF = datoRetorno;
          }

          if(this.respuestaF.estatus == 'OK'){
            this.contadorPagados = this.contadorPagados + 1;
            input.estatus = "Pagado";
            this.pagado = true;
            input.id_factura = this.respuestaF.idFactura;
          }else{
            input.estatus = "No Pagado";
            if(this.respuestaF.idFactura){
              input.id_factura = this.respuestaF.idFactura;
            }
            this.no_pagado = true;
            this.contadorNpagados = this.contadorNpagados + 1;
            if(this.respuestaF.estatus){
              let errorP = this.respuestaF.estatus + " Cuenta Agua: "; input.cuentaAgua;
              throw new Error(errorP);
            }else{
              let errorP = datoRetorno.toString() + " Cuenta Agua: " + input.cuentaAgua;
              throw new Error(errorP);

            }
          }
       
        }catch(e){
          this.muestraMensaje.error(e.message, "top", "center");
        }
         
      }  
      this.totalRegrstro = this.contadorPagados + this.contadorNpagados;
      this.totalAplicados = this.contadorPagados;
      this.totalNoAplicados = this.contadorNpagados;
    } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
      
    } finally {
      console.log("Paso por pagar");
      this.progressBar = false;
    }  

  }



  async getAllCatMedioPagos() {
    try {
      const datoRetorno = await this.catMedioPagosService.getAll().toPromise();
      this.catMedioPagos = datoRetorno.map((datos) => {
        return { descripcion: datos.descripcion, id: datos.id, clave: datos.clave };
      });

      this.catMedioPagos.unshift({ descripcion: "Todos", id: null });
    //  this.catMedioPagos = datoRetorno;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log('Paso por getCatMedioPagos', this.catMedioPagos);
    }
  }

  async onTipoOrdenSelec(renglon: any, event: any)
  { 
    renglon.Mediodescripcion = event.value?.descripcion;
    renglon.id_medio_pago    = event.value?.id;

  }
  
}